import { css } from "@compiled/react";
import { useIntl } from "react-intl";

const searchIconStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
    border: 0,
    cursor: "pointer",
    padding: 0
});

const svgStyle = css({
    "width": "24px",
    "height": "24px",
    "zIndex": "1",
    "path": {
        color: "#64686f"
    },
    "&:hover path": {
        stroke: "#1868db"
    }
});

const SearchButton = (props: {
    readonly onClick: React.MouseEventHandler<HTMLButtonElement>;
}) => {
    const intl = useIntl();
    const translated = {
        searchLabel: intl.formatMessage({
            id: "globalnav.v2.search.label",
            defaultMessage: "Search"
        })
    };

    return (
        <button
            css={searchIconStyle}
            onClick={props.onClick}
            id="global-nav-search-icon"
            aria-label={translated.searchLabel}
            data-testid="global-nav-search-icon"
            data-event="clicked"
            data-event-component="linkButton"
            data-event-container="globalNavWac"
            data-product-key="jiraSoftware"
            role={translated.searchLabel}
        >
            <svg
                css={svgStyle}
                width="23"
                height="25"
                viewBox="0 0 23 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M17.0918 18.5623L20.2497 21.7201"
                    stroke="#101214"
                    strokeWidth="2.75"
                    strokeLinecap="round"
                />
                <path
                    d="M10.8417 19.1316C15.289 19.1316 18.8943 15.5263 18.8943 11.079C18.8943 6.63165 15.289 3.02637 10.8417 3.02637C6.39435 3.02637 2.78906 6.63165 2.78906 11.079C2.78906 15.5263 6.39435 19.1316 10.8417 19.1316Z"
                    stroke="#101214"
                    strokeWidth="2.25"
                />
            </svg>
        </button>
    );
};

export default SearchButton;
